import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import pinia from './store';
import { useLayoutStore } from './store/layout';
import BootstrapVueNext from 'bootstrap-vue-next';
import PhosphorIcons from '@phosphor-icons/vue';
import Wizard from 'form-wizard-vue3';
import RoleAccess from './directives/role-access';
import { initSentry } from './services/sentry';
import { VueUmamiPlugin } from '@jaseeey/vue-umami-plugin';
import { umamiConfig } from './services/analytics';
import Plausible from 'plausible-tracker';
// import CoolLightBox from 'vue-cool-lightbox';

// Packages CSS import
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import '@vueform/slider/themes/default.css';
import 'form-wizard-vue3/dist/form-wizard-vue3.css';
import 'simplebar-vue/dist/simplebar.min.css';

import '@/assets/scss/style.scss';

// bootstrap.bundle.js
import 'bootstrap/dist/js/bootstrap.bundle.js';

const app = createApp(App);

// Usar Pinia
app.use(pinia);

// Inicializar layout após configurar Pinia
const layoutStore = useLayoutStore();
layoutStore.initializeLayout();

// Inicializar Sentry
if (process.env.NODE_ENV !== 'development') {
  initSentry(app);
} else {
  console.log(
    '[Sentry] Monitoramento desativado no ambiente de desenvolvimento'
  );
}

// Configurar Umami Analytics
app.use(VueUmamiPlugin, {
  ...umamiConfig,
  router,
});

// Configurar Plausible Analytics (usando plausible-tracker)
const plausibleDomain = process.env.VUE_APP_PLAUSIBLE_DOMAIN;
const plausibleApiHost = process.env.VUE_APP_PLAUSIBLE_API_HOST;

if (plausibleDomain && plausibleApiHost) {
  const { enableAutoPageviews, enableAutoOutboundTracking } = Plausible({
    domain: plausibleDomain,
    apiHost: plausibleApiHost,
    trackLocalhost: true,
  });
  
  // Ativar tracking automático
  enableAutoPageviews();
  enableAutoOutboundTracking();
  
  console.log('[Plausible] Analytics configurado para:', plausibleDomain);
} else {
  console.log('[Plausible] Variáveis de ambiente não configuradas, tracking desativado');
}

app
  .use(router)
  .use(BootstrapVueNext)
  .use(PhosphorIcons)
  .use(RoleAccess)
  // .use(CoolLightBox)
  .component('Wizard', Wizard)
  .mount('#app');
